"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRewardsSchema = exports.UserAllocationRewardSchema = exports.UserMerkleRewardSchema = exports.MerkleClaimInfoSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.MerkleClaimInfoSchema = zod_1.z.object({
    index: zod_1.z.number(),
    amount: zod_1.z.string(),
    proof: zod_1.z.array(zod_1.z.string()),
});
exports.UserMerkleRewardSchema = zod_1.z.object({
    name: zod_1.z.string({ required_error: 'name is required' }),
    address: zod_1.z.string({ required_error: 'address is required' }),
    totalAmount: core_contracts_ifaces_1.TokenAmountSchema,
    distributed: core_contracts_ifaces_1.TokenAmountSchema,
    available: core_contracts_ifaces_1.TokenAmountSchema,
    claimInfo: exports.MerkleClaimInfoSchema.optional().nullable(),
});
exports.UserAllocationRewardSchema = zod_1.z.object({
    name: zod_1.z.string({ required_error: 'name is required' }),
    address: zod_1.z.string({ required_error: 'address is required' }),
    released: core_contracts_ifaces_1.TokenAmountSchema,
    distributed: core_contracts_ifaces_1.TokenAmountSchema,
    available: core_contracts_ifaces_1.TokenAmountSchema,
    earned: core_contracts_ifaces_1.TokenAmountSchema,
    progress: zod_1.z.number({ required_error: 'progress is required' }),
});
exports.UserRewardsSchema = zod_1.z.object({
    merkle: zod_1.z.array(exports.UserMerkleRewardSchema),
    allocation: zod_1.z.array(exports.UserAllocationRewardSchema),
});
